"use client"

import React, { useState, useEffect } from "react"
import { FaChevronDown, FaChevronUp, FaTimes } from "react-icons/fa"
import { Row, Col, Card, FormControl, Button, Container, Accordion, Badge } from "react-bootstrap"
import { searchNumber } from "../../../services/rifa.service"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Desencrypt } from "../../../utilities/cipher"
import { LoadingMovilGo } from "../../../shared/components/loadingMovilGo"
import { ModalNotificationTransaction } from "../../../shared/components/modalNotificationTransaction"
import "./styles.css"
import {
    Url_Home,
    Url_pago,
    idCallcenter,
    idCardosoVendedor,
    idMobilgoVendedor,
    idvendedorqr,
} from "../../../utilities/odoo-config"
import { ListNumberTicketLandinPage } from "../../../shared/components/list-prices"

const SeleccionarBoleta = (props) => {
    console.log("datos del landing page", props.datos)
    console.log("datos rifa", JSON.parse(localStorage.getItem("datosRifa")))

    const datos = props.datos
    const partnerId = datos.partner_id
    const userTicket = datos.identificacion + " - " + datos.nombre
    const identificacion = datos.identificacion
    const telefono = datos.telefono
    const email = datos.correo
    const fullNameUser = datos.nombre + " " + datos.apellido

    const [boleta, setBoleta] = useState("")
    const [firstLoad, setFirstLoad] = useState(true)
    const [visibleRegistro, setVisibleRegistro] = useState(false)
    const [visibleBoletas, setVisibleBoletas] = useState(false)
    const [numberTicket, setNumberTicket] = useState("")
    const [numberTicketSearch, setNumberTicketSearch] = useState("")
    const [active, setActive] = useState(<></>)
    const [styleTicket, setStyleTicket] = useState({})
    const [viewTicket, setViewTicket] = useState(false)
    const [prices, setPrices] = useState([])
    const [loading, setLoading] = useState(false)
    const [opacity, setOpacity] = useState(1)
    const [modalNotification, setModalNotification] = useState(false)
    const [luckyNumber, setLuckyNumber] = useState(false)
    const [rifa, setRifa] = useState(JSON.parse(localStorage.getItem("datosRifa")))
    const [idProduct, setIdProduct] = useState(-1)
    const [showComprar, setShowComprar] = useState(true)
    const [numbersTicket, setNumbersTicket] = useState([])
    const [whoPress, setwhoPress] = useState("")
    const [numbersTicketAvailable, setNumbersTicketAvailable] = useState([])
    const [numbersTicketlucky, setNumbersTicketLucky] = useState([])
    const [numSuerte, setNumSuerte] = useState(0)
    const [selectedTickets, setSelectedTickets] = useState([])

    const session = Desencrypt()
    const idPadre = localStorage.getItem("idPadre")
    const [activeSection, setActiveSection] = useState("buscadorNumero")

    useEffect(() => {
        const idPadre = localStorage.getItem("idPadre")
        const datoSession = Desencrypt()
        if (
            datoSession.id === idCardosoVendedor ||
            datoSession.id === idMobilgoVendedor ||
            datoSession.id === idCallcenter ||
            datoSession.id === idvendedorqr
        ) {
            setShowComprar(false)
        } else {
            setShowComprar(true)
        }

        const initializeComponent = async () => {
            numeroDeLaSuerte(false)
            await new Promise((resolve) => setTimeout(resolve, 200))
            numeroDeLaSuerte(true)
            setFirstLoad(false)
        }

        if (firstLoad) {
            initializeComponent()
        }
    }, [])

    const selectTicket = (number, selector) => {
        if (!selectedTickets.some((ticket) => ticket.numero === number)) {
            const newTicket = {
                numero: number,
                precio: rifa.precio,
            };
            setSelectedTickets((prev) => {
                const updatedTickets = [...prev, newTicket];
                props.numberTicket(updatedTickets);
                toast.success(`¡Boleto ${number} agregado exitosamente!`);
                return updatedTickets;
            });
        } else {
            toast.warning("Este boleto ya está seleccionado");
        }

        setNumberTicket(number);

        if (selector === "numeroJugar") {
            setwhoPress("numeroJugar");
        } else {
            setwhoPress("");
        }
        clearSelectors();
    }

    const clearSelectors = () => {
        setNumberTicketSearch("")
        setNumbersTicket([])
        setStyleTicket({})
        setViewTicket(false)
    }

    const clearNumbersOnly = () => {
        setNumbersTicket([])
        setNumbersTicketAvailable([])
        setNumbersTicketLucky([])
        setNumSuerte(0)
        setwhoPress("")
    }

    const removeTicketFromSelection = (ticketId) => {
        setSelectedTickets((prev) => {
            const newTickets = prev.filter((ticket) => ticket.id !== ticketId);
            props.numberTicket(newTickets);
            toast.info("Boleto eliminado de la selección");

            if (newTickets.length === 0) {
                setNumberTicket("");
                props.numberTicket("");
            }
            return newTickets;
        });
    };

    const calculateTotal = () => {
        return selectedTickets.reduce((total, ticket) => total + ticket.precio, 0)
    }

    const showModal = (flag) => {
        setVisibleRegistro(flag)
        setBoleta("")
        setVisibleBoletas(flag)
    }

    const chooseTicket = (flag) => {
        setVisibleBoletas(flag)
        setStyleTicket({ borderWidth: 2, borderColor: "#07A2BA" })
        setViewTicket(true)
    }

    const foundNumber = (response, flag) => {
        const encontrada = () => toast.info("¡Se encontró la boleta solicitada!")
        const boletasRelacionadas = () =>
            toast.warning("¡No se encontró la boleta solicitada, pero hay algunas con relación!")

        if (flag) {
            let esta = false
            let boletaNoEncontrada = false
            const newNumber = []
            setIdProduct(response.disponibles[0].product_id)

            for (let k = 0; k < 6; k = k + 1) {
                newNumber.push(response.disponibles[k])
            }
            setNumbersTicket(newNumber)
            setNumbersTicketAvailable(newNumber)

            if (response?.errores) {
                alert("Se produjo un error al consultar la boleta")
                return
            } else if (response.disponibles.length > 0) {
                for (let index = 0; index < response.disponibles.length; index++) {
                    if (numberTicket == response.disponibles[index].numero_boleta) {
                        esta = true
                    }
                    if (numberTicketSearch !== "" && numberTicketSearch !== response.disponibles[index].numero_boleta) {
                        boletaNoEncontrada = true
                    } else if (numberTicketSearch == response.disponibles[index].numero_boleta) {
                        esta = true
                        boletaNoEncontrada = false
                    }
                }

                if (boletaNoEncontrada) {
                    boletasRelacionadas()
                }

                if (esta) {
                    encontrada()
                    setStyleTicket({ borderWidth: 2, borderColor: "#07A2BA" })
                    setViewTicket(true)
                    setLoading(false)
                    setOpacity(1)
                } else {
                    setVisibleBoletas(true)
                    setLoading(false)
                    setOpacity(1)
                }
            }
        }
    }

    const searchTicket = () => {
        const errorDigitar = () => toast.error("¡No se le olvide digitar un número de boleta!")
        const rifa = JSON.parse(localStorage.getItem("datosRifa"))

        if (numberTicketSearch.trim() !== "") {
            setLoading(true)
            setOpacity(0.4)
            searchNumber(numberTicketSearch, rifa.id, foundNumber)
        } else {
            errorDigitar()
        }
    }

    const numeroDeLaSuerte = (flag) => {
        setLuckyNumber(flag)
        const min = 1
        const max = 999
        const numeroAleatorio = Math.floor(Math.random() * (max - min)) + min
        setNumSuerte(numeroAleatorio)

        setNumbersTicket([])
        setNumbersTicketAvailable([])
        setNumberTicketSearch("")
        setNumbersTicketLucky([])
        setwhoPress("numeroJugar")
    }

    useEffect(() => {
        const delayedSearch = () => {
            const searchTicket = () => {
                const rifa = JSON.parse(localStorage.getItem("datosRifa"))
                if (numSuerte !== 0) {
                    setLoading(true)
                    setOpacity(0.4)
                    searchNumber(numSuerte, rifa.id, foundNumber)
                }
            }
            searchTicket()
        }

        const delay = setTimeout(delayedSearch, 100)
        return () => clearTimeout(delay)
    }, [numSuerte])

    const handleChange = (event) => {
        setNumSuerte(0)
        setNumbersTicketAvailable([])
        setNumberTicketSearch(event.target.value.replace(/\D/, ""))
        setStyleTicket({ borderWidth: 1 })
        setViewTicket(false)
        setLuckyNumber(false)
        if (event.target.value === "") {
            setNumbersTicket([])
            setNumbersTicketAvailable([])
        }
    }

    const toggleSection = (section) => {
        setActiveSection((prev) => (prev === section ? null : section))
    }

    const accordionBodyStyle = {}

    const headerStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "10px",
        backgroundColor: "#f8f9fa",
        cursor: "pointer",
        borderRadius: 8,
        borderBottom: "3px solid #ddd",
        borderTop: "1px solid #ddd",
    }

    const buttonStyle = {
        textDecoration: "none",
        fontWeight: "bold",
        color: "gray",
        fontSize: "16px",
    }

    const iconStyle = {
        fontSize: "16px",
        transition: "transform 0.3s ease",
    }

    return (
        <Container fluid>
            {selectedTickets.length > 0 && (
                <Row className="justify-content-center" style={{ marginTop: "30px", marginBottom: "30px" }}>
                    <Col md={12}>
                        <Card style={{ borderRadius: "15px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", height: 'auto', maxHeight: "none" }}>
                            <Card.Header style={{ backgroundColor: "#07A2BA", color: "white", textAlign: "center" }}>
                                <h5 style={{ margin: 0 }}>
                                    <Badge bg="light" text="dark" style={{ marginRight: "10px" }}>
                                        {selectedTickets.length}
                                    </Badge>
                                    Boletas Seleccionadas
                                </h5>
                            </Card.Header>
                            <Card.Body>
                                <Row>
                                    {selectedTickets.map((ticket) => (
                                        <Col md={4} sm={6} xs={12} key={ticket.id} style={{ marginBottom: "15px" }}>
                                            <Card
                                                style={{
                                                    border: "2px solid #07A2BA",
                                                    borderRadius: "10px",
                                                    position: "relative",
                                                    height: "auto",
                                                }}
                                            >
                                                <Card.Body className="text-center" style={{ padding: "15px" }}>
                                                    <Button
                                                        variant="outline-danger"
                                                        size="sm"
                                                        onClick={() => removeTicketFromSelection(ticket.id)}
                                                        style={{
                                                            position: "absolute",
                                                            top: "5px",
                                                            right: "5px",
                                                            borderRadius: "50%",
                                                            width: "25px",
                                                            height: "25px",
                                                            padding: "0",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                        }}
                                                    >
                                                        <FaTimes size={12} />
                                                    </Button>
                                                    <h4 style={{ color: "#07A2BA", fontWeight: "bold", marginBottom: "10px" }}>
                                                        {ticket.numero}
                                                    </h4>
                                                    <p style={{ margin: 0, fontSize: "14px", color: "#666" }}>
                                                        ${ticket.precio.toLocaleString()}
                                                    </p>
                                                    <Badge
                                                        bg={
                                                            ticket.source === "search"
                                                                ? "primary"
                                                                : "info"
                                                        }
                                                        style={{ fontSize: "10px", marginTop: "5px" }}
                                                    >
                                                        {ticket.source === "search"
                                                            ? "Búsqueda"
                                                            : "Aleatorio"}
                                                    </Badge>
                                                </Card.Body>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <h5 style={{ color: "#07A2BA" }}>
                                            Total: ${calculateTotal().toLocaleString()}
                                        </h5>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            )}

            <Row className="justify-content-center">
                <div className="text-container">
                    <h2 className={"defaultTitle"}>{selectedTickets.length > 0 ? 'PUEDES SELECCIONAR MAS BOLETAS' : 'BOLETAS DISPONIBLES'}</h2>
                    <h6>{selectedTickets.length > 0 ? 'Selecciona mas boletas preferidas' : 'Elije tu número de boleta con algunas de las 2 opciones' }</h6>
                </div>
            </Row>

            <div style={{ marginBottom: "10px" }}>
                <Accordion activeKey={activeSection === "buscadorNumero" ? "0" : null}>
                    <div style={{ marginBottom: 20 }}>
                        <div style={headerStyle} onClick={() => toggleSection("buscadorNumero")}>
                            <Button variant="link" style={buttonStyle}>
                                Buscar tu número preferido
                            </Button>
                            {activeSection === "buscadorNumero" ? (
                                <FaChevronUp style={iconStyle} />
                            ) : (
                                <FaChevronDown style={iconStyle} />
                            )}
                        </div>
                        <Accordion.Collapse eventKey="0">
                            <div style={accordionBodyStyle}>
                                <Row className="justify-content-center">
                                    <Col md={12}>
                                        <ToastContainer autoClose={2000} />
                                        <div style={{ marginTop: "2%" }}>
                                            <div className="custom-search-bar">
                                                <FormControl
                                                    style={{ width: "100%", borderRadius: "20px" }}
                                                    type="number"
                                                    placeholder="Busca tu número preferido"
                                                    aria-label="Número de la boleta"
                                                    value={numberTicketSearch}
                                                    onChange={handleChange}
                                                    onInput={(e) => {
                                                        if (e.target.value.length > 4) {
                                                            e.target.value = e.target.value.slice(0, 4);
                                                        }
                                                    }}
                                                    inputMode="numeric"
                                                    pattern="[0-9]{4}"
                                                />
                                                <Button className="custom-search-bar button" onClick={searchTicket}>
                                                    Buscar
                                                </Button>
                                            </div>
                                            {numberTicketSearch && (
                                                <ListNumberTicketLandinPage
                                                    active={(flag) => setActive(flag)}
                                                    selectTicket={(number) => selectTicket(number)}
                                                    selectedTicket={numberTicket}
                                                    selectedTickets={selectedTickets}
                                                    numbers={numbersTicketAvailable}
                                                />
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Accordion.Collapse>
                    </div>
                </Accordion>

                <Accordion activeKey={activeSection === "numeroJugar" ? "1" : null}>
                    <div style={{ marginBottom: 20 }}>
                        <div style={headerStyle} onClick={() => {toggleSection("numeroJugar"); setNumbersTicket([])}}>
                            <Button variant="link" style={buttonStyle}>
                                Generar Números aleatorios para tu juego
                            </Button>
                            {activeSection === "numeroJugar" ? (
                                <FaChevronUp style={iconStyle} />
                            ) : (
                                <FaChevronDown style={iconStyle} />
                            )}
                        </div>
                        <Accordion.Collapse eventKey="1">
                            <div style={accordionBodyStyle}>
                                <Row className="justify-content-center">
                                    <Col md={12}>
                                        <div className="d-flex align-items-center align-items-center">
                                            <Button
                                                onClick={() => numeroDeLaSuerte(false)}
                                                variant="info"
                                                style={{ marginTop: "10px", marginRight: "10%" }}
                                            >
                                                Nuevos números
                                            </Button>
                                            {numbersTicket.length > 0 && (
                                                <ListNumberTicketLandinPage
                                                    active={(flag) => setActive(flag)}
                                                    selectTicket={(number) => selectTicket(number, "numeroJugar")}
                                                    selectedTicket={numberTicket}
                                                    selectedTickets={selectedTickets}
                                                    numbers={numbersTicket}
                                                />
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Accordion.Collapse>
                    </div>
                </Accordion>
            </div>



            <Col md={12}>
                {loading && <LoadingMovilGo />}
                {modalNotification && (
                    <ModalNotificationTransaction
                        closeModal={(flag) => setModalNotification(flag)}
                        type={"Rifa"}
                        message={"Rifa comprada exitosamente"}
                    />
                )}
            </Col>
        </Container>
    )
}

export default SeleccionarBoleta